import { Axios } from 'axios';
import { ITrustedEmailCreateReqBody } from 'components/AppNotifications/TrustedEmailsModal/types';
import { IGetTrustedEmailDto } from 'components/AppNotifications/TrustedEmailsModal/types/dtos';
import apiClient, { IResponse } from 'services/api/axios';

class TrustedEmailService {
  api: Axios;

  constructor(api: Axios) {
    this.api = api;
  }

  getTrusatedEmailList() {
    return this.api.get<IGetTrustedEmailDto>('/api/v1/trusted-emails', {
      baseURL: '/panel-main',
    });
  }

  createTrustedEmail(body: ITrustedEmailCreateReqBody) {
    return this.api.post<IResponse>('/api/v1/trusted-emails', body, {
      baseURL: '/panel-main',
    });
  }

  resendTrustedEmail(id: number) {
    return this.api.post<IResponse>(`/api/v1/trusted-emails/${id}/resend`, undefined, {
      baseURL: '/panel-main',
    });
  }

  confirmTrustedEmail(token: string) {
    return this.api.get(`/api/v1/trusted-emails/confirm?token=${token}`, {
      baseURL: '/panel-main',
    });
  }

  deleteTrustedEmail(id: number) {
    return this.api.delete(`/api/v1/trusted-emails/${id}`, {
      baseURL: '/panel-main',
    });
  }
}

export default new TrustedEmailService(apiClient);
